import type { SVGProps } from "react";
export interface ShareSquareIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function ShareSquareIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: ShareSquareIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M1.875 18V6A4.125 4.125 0 0 1 6 1.875h3a1.125 1.125 0 0 1 0 2.25H6c-1.036 0-1.875.84-1.875 1.875v12c0 1.035.84 1.875 1.875 1.875h12c1.035 0 1.875-.84 1.875-1.875v-3a1.125 1.125 0 0 1 2.25 0v3A4.125 4.125 0 0 1 18 22.125H6A4.125 4.125 0 0 1 1.875 18"
      />
      <path
        fill={color}
        d="m16.1.882.168.022c.377.071.65.282.783.388.178.143.38.34.577.529l4.39 4.219c.196.187.393.376.546.549.12.137.252.307.355.518l.094.225.047.165c.096.39.08.799-.047 1.18a2.15 2.15 0 0 1-.45.743c-.152.173-.349.362-.544.55l-4.39 4.22c-.197.19-.4.385-.578.527-.151.122-.487.38-.952.41a1.63 1.63 0 0 1-1.346-.574c-.3-.355-.348-.776-.365-.97-.02-.227-.019-.509-.019-.782v-1.136c-1.862.131-3.628.687-5.574 2.632a1.125 1.125 0 0 1-1.92-.796c0-4.69 2.916-8.51 7.494-9.05V3.207c0-.273-.001-.555.02-.782.016-.194.064-.614.364-.97l.132-.139c.279-.26.64-.415 1.022-.435h.192Zm.513 4.476a1.37 1.37 0 0 1-.705 1.104 1.4 1.4 0 0 1-.508.16 4 4 0 0 1-.253.018c-2.702.126-4.753 1.743-5.599 4.204 1.878-1.133 3.705-1.427 5.524-1.462.05 0 .157-.003.257.003.087.006.219.02.369.07l.154.065.189.113q.178.128.309.305l.115.184.07.155c.053.15.07.283.077.368.008.1.007.207.007.258v1.135l3.841-3.69c.164-.157.267-.265.343-.343a12 12 0 0 0-.343-.342L16.62 3.97v1.137c0 .052 0 .156-.007.251"
      />
    </svg>
  );
}
